var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-community-health.e0b35dc9.png","uri@2x": __webpack_public_path__ + "icon-community-health.45b5397b.png","uri@3x": __webpack_public_path__ + "icon-community-health.a9da65cd.png",
    width: 20,
    height: 20
});